import { useCallback } from "react"
import { useGoogleReCaptcha } from "@google-recaptcha/react"

/**
 * Hook to handle reCAPTCHA verification
 * Returns a function that executes reCAPTCHA and returns the token
 */
export const useRecaptcha = () => {
  const { executeV3 } = useGoogleReCaptcha()

  const verifyRecaptcha = useCallback(
    async (action: string = "send_sms"): Promise<string | null> => {
      if (!executeV3) {
        return null
      }

      try {
        return await executeV3(action)
      } catch (error) {
        console.error("Error verifying reCAPTCHA", error)
        return null
      }
    },
    [executeV3]
  )

  return { verifyRecaptcha }
}
